import type { SiteConfig } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ImageField, SelectField } from './fields.tsx';

export function SeoSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const s = config.seo;
  const set = (patch: Partial<SiteConfig['seo']>) => update({ seo: { ...s, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>SEO</h2>
      <TextField label="Meta title" value={s.metaTitle} onChange={(v) => set({ metaTitle: v })} />
      <TextAreaField label="Meta description" value={s.metaDescription} onChange={(v) => set({ metaDescription: v })} rows={3} />
      <ImageField label="Image Open Graph" value={s.ogImage} onChange={(v) => set({ ogImage: v })} />
      <SelectField
        label="Indexation"
        value={s.robots}
        onChange={(v) => set({ robots: v })}
        options={[{ value: 'index', label: 'Indexer (index)' }, { value: 'noindex', label: 'Ne pas indexer (noindex)' }]}
      />

      <div className="card" style={{ marginTop: 20 }}>
        <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginBottom: 6 }}>Aperçu Google</div>
        <div style={{ color: '#1a0dab', fontSize: 16, fontWeight: 500 }}>{s.metaTitle || 'Titre de la page'}</div>
        <div style={{ color: '#006621', fontSize: 12.5, margin: '2px 0' }}>mon-extra.fr</div>
        <div style={{ color: '#545454', fontSize: 12.5 }}>{s.metaDescription || 'Description de la page…'}</div>
      </div>
    </div>
  );
}
